import React, { useState } from "react";

const SelectRoleAlert = ({ open, options, onClose, onConfirm }) => {
  const [selected, setSelected] = useState(null);

  if (!open) return null;

  const handleConfirm = () => {
    if (selected) {
      onConfirm(selected);
      onClose();
    } else {
      alert("Please select an option first.");
    }
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.alertBox}>
        <h3>Select an option</h3>

        {options.map((opt) => (
          <label key={opt.value} style={styles.radioRow}>
            <input
              type="radio"
              name="alert-radio"
              value={opt.value}
              checked={selected === opt.value}
              onChange={(e) => setSelected(e.target.value)}
            />
            {opt.label}
          </label>
        ))}

        <div style={styles.actions}>
          <button onClick={onClose}>Cancel</button>
          <button onClick={handleConfirm}>Confirm</button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    zIndex: 1000,
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.4)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  alertBox: {
    zIndex: 1000,
    background: "#fff",
    padding: 20,
    borderRadius: 8,
    width: 300,
    boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
  },
  radioRow: { zIndex: 1000, display: "block", margin: "8px 0" },
  actions: { zIndex: 1000, display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 15 },
};

export default SelectRoleAlert;